module.exports = __webpack_public_path__ + "static/media/retail-store.f6ad40d6.svg";